import styled from 'styled-components';
import { device } from './deviceSize';

const Container = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
`;

const Navbar = styled.div`
    width: 100%;
    height: 200px;
    background-color: #e82764;
    display: flex;
    align-items: center;
    flex-direction: column;

    @media ${device.mobileL} {
        height: 270px;
    }
`;

const YourChoose = styled.div`
    margin-top: 25px;
    font-size: 40px;
    color: white;

    @media ${device.mobileL} {
        margin-top: 35px;
        font-size: 30px;
        padding: 0 5px 0 5px;
    }
`;

const PodpiszPls = styled.div`
    font-size: 20px;
    margin-top: 20px;
    color: white;
    text-align: center;

    @media ${device.mobileL} {
        margin: 20px 20px 0 20px;
    }
`;

export {
    Container,
    Navbar,
    YourChoose,
    PodpiszPls
}